<div *ngIf="!playlist">
  {{'lang.globals.noData'| translate}}
</div>
<div class="row" *ngIf="playlist">
  <div class="col-12">
    <div *ngFor="let iteration of playlist?.iterations">

      <sb-card>
        <div card-header>
          Iteration {{iteration?.index + 1}}
        </div>
        <div card-body>
          <ng-scrollbar [track]="'horizontal'" autoHeightDisabled="false">

            <table class="table mb-2">
              <thead>
              <tr>
                <th>Slot</th>
                <th>{{'lang.schedules.schedule' |translate}}</th>
                <th>{{'lang.globals.booking'|translate}}</th>
                <th>{{'lang.globals.advertiser'|translate}}</th>
                <th>SSP</th>
                <th>{{'lang.globals.targetedBookings' |translate}}</th>
              </tr>
              </thead>
              <tbody>

              <tr *ngFor="let slot of iteration?.slots; index as i">
                <td>
                  Slot {{i + 1}}
                </td>
                <td>
                  {{slot?.slot?.name}}(Slot {{slot?.slot?.orderNum + 1}})
                </td>
                <ng-container *ngIf="slot.staticBooking">

                <td>

                  <sb-comp-image-name-wrapper [medium]="bookingMap.get(slot?.staticBooking?.id)?.medium"
                                              [still]="true"
                                              [hoverPreview]="true">
                    <span firstLine [innerHTML]="bookingMap.get(slot?.staticBooking?.id)?.medium?.name | truncate:30"></span>
                    <span secondLine> {{'lang.globals.commercial'|translate}}: <span
                      [innerHTML]="bookingMap.get(slot?.staticBooking?.id)?.name |truncate:30"></span>
                                                    </span>
                    <span thirdLine
                          *ngIf="bookingMap.get(slot?.staticBooking?.id)?.templateDataSet"> {{'lang.globals.templateDataset'|translate}}:
                            <span
                              [innerHTML]="bookingMap.get(slot?.staticBooking?.id)?.templateDataSet?.name | truncate:25">
                            </span>
                          </span>
                  </sb-comp-image-name-wrapper>
                </td>
                <td>
                  <sb-comp-image-name-wrapper [image]="bookingMap.get(slot?.staticBooking?.id)?.advertiser?.logo?.url">
                    <span [innerHTML]="bookingMap.get(slot?.staticBooking?.id)?.advertiser?.name | truncate : 35" firstLine></span>
                  </sb-comp-image-name-wrapper>
                </td>
                </ng-container>
                <ng-container *ngIf="!slot.staticBooking">
                  <td colspan="2">
                    <b><i>{{'lang.globals.noStaticBookings'| translate}}</i></b>
                  </td>
                </ng-container>
                <td>
                  <ng-container *ngIf="slot?.sspSlotConfigurations?.length > 0">
                  <div *ngFor="let config of slot?.sspSlotConfigurations">
                    <sb-comp-image-name-wrapper [image]="config?.contract?.ssp?.primaryCompany?.logo?.url">
                      <span firstLine [innerHTML]="config.identifier | truncate: 35"></span>
                    </sb-comp-image-name-wrapper>
                  </div>
                  </ng-container>
                  <ng-container *ngIf="slot?.sspSlotConfigurations?.length <= 0">
                    <i>{{'lang.globals.noSSP' |translate}}</i>
                  </ng-container>
                </td>
                <td>
                <ng-container *ngIf="slot?.targetedBookingSetIndex != null">
                  <a class="link" (click)="showBookingSet(slot?.targetedBookingSetIndex)">
                    {{'lang.globals.bookingSet'|translate}} {{slot?.targetedBookingSetIndex}}
                  </a>
                </ng-container>
                <ng-container *ngIf="slot?.targetedBookingSetIndex == null">
                  <i>{{'lang.globals.noTargetedBookings'|translate}}</i>
                </ng-container>
                </td>

              </tr>
              </tbody>
            </table>
          </ng-scrollbar>
        </div>
      </sb-card>
    </div>
  </div>
</div>
